import groupUppMark from '../assets/groupupp-mark.png';
import { Icon } from './Icons';

export function ProductPreview() {
  return (
    <div className="product-visual" aria-label="Illustrated preview of the Group Upp app">
      <span className="orbit orbit--one" />
      <span className="orbit orbit--two" />
      <div className="float-card float-card--score">
        <span className="float-icon float-icon--gold">1</span>
        <span><b>Weekly lead</b><small>+3 points today</small></span>
      </div>
      <div className="float-card float-card--reaction">
        <span className="reaction-stack">👏</span>
        <span><b>Friends reacted</b><small>Made their day</small></span>
      </div>

      <div className="phone-frame">
        <div className="phone-speaker" />
        <div className="phone-screen">
          <div className="app-header">
            <img src={groupUppMark} alt="" />
            <div>
              <span>Good morning</span>
              <strong>Your group is active</strong>
            </div>
            <span className="avatar">KV</span>
          </div>

          <div className="race-card">
            <div className="race-heading">
              <span className="eyebrow-mini">TODAY'S RACE</span>
              <span className="live-dot">Open</span>
            </div>
            <h3>Pattern Vault</h3>
            <div className="pattern-row" aria-hidden="true">
              <span>△</span><span>○</span><span>◇</span><span>?</span>
            </div>
            <button type="button" tabIndex={-1}>Play today's puzzle <Icon name="arrow" /></button>
          </div>

          <div className="app-section-title">
            <strong>Friends' activity</strong><span>See all</span>
          </div>
          <div className="feed-card">
            <div className="feed-user"><span className="mini-avatar">F</span><span><b>A friend</b><small>Your group · 12 min</small></span></div>
            <p>Completed today's <b>Pattern Vault</b> in <b>41 seconds</b>.</p>
            <div className="feed-actions"><span>👏 4</span><span>😮 2</span><span className="react-label">React</span></div>
          </div>

          <div className="app-tabs">
            <span className="tab-active"><Icon name="heart" /><small>Home</small></span>
            <span><Icon name="group" /><small>Groups</small></span>
            <span className="tab-center"><Icon name="puzzle" /></span>
            <span><Icon name="layers" /><small>Rankings</small></span>
            <span><span className="tab-avatar">K</span><small>You</small></span>
          </div>
        </div>
      </div>
      <span className="product-visual-caption">Illustrative product preview</span>
    </div>
  );
}
